<nav class="menu-sidebar" aria-label="Menu principal">
	<a routerLink="/main/welcome" class="menu-sidebar__brand">
		<img
			src="assets/Icone.png"
			alt="Potamos"
			class="menu-sidebar__logo"
		/>
		<span class="menu-sidebar__brand-name">Potamos</span>
	</a>

	<div class="menu-sidebar__nav">
		<div class="menu-sidebar__group menu-sidebar__group--top">
			<div class="menu-sidebar__group-header">
				<span>Dashboard</span>
			</div>
			<div class="menu-sidebar__group-items">
				<a
					routerLink="/main/welcome"
					routerLinkActive="menu-sidebar__item--active"
					class="menu-sidebar__item"
				>
					<i class="pi pi-home"></i>
					<span>Visão Geral</span>
				</a>
			</div>
		</div>

		@for (group of groups; track group.label) {
			<div class="menu-sidebar__group">
				@if (group.collapsible) {
					<button
						type="button"
						class="menu-sidebar__group-header menu-sidebar__group-header--toggle"
						(click)="toggleGroup(group.label)"
					>
						<span>{{ group.label }}</span>
						<i
							class="pi pi-chevron-down menu-sidebar__chevron"
							[class.menu-sidebar__chevron--open]="isGroupExpanded(group.label)"
						></i>
					</button>
				} @else {
					<div class="menu-sidebar__group-header">
						<span>{{ group.label }}</span>
					</div>
				}

				@if (!group.collapsible || isGroupExpanded(group.label)) {
					<div class="menu-sidebar__group-items">
						@for (item of group.items; track item.route) {
							<a
								[routerLink]="item.route"
								routerLinkActive="menu-sidebar__item--active"
								class="menu-sidebar__item"
							>
								<i [class]="item.icon"></i>
								<span>{{ item.label }}</span>
							</a>
						}
					</div>
				}
			</div>
		}
	</div>
</nav>
